import customAxios from '../../customHook/customAxios';
import { getAuthHeader } from '../../utils';

export const v3_my_appraisal_formData = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/appraisal/formData`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    });
};


export const v3_submit_appraisal_form = async (payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/appraisal/application`;
    return customAxios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    });
};

export const v3_submitted_appraisal_forms = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/appraisal/submitted/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

